module.exports = __webpack_public_path__ + "static/img/KK-2.738769b3.png";